





























































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import List from '@/components/util/List.vue';
import {
  WorkersApi,
  ApiWorkersGetRequest,
  Worker,
  WorkerPagedCollectionApiResponse,
  SystemApi,
  ValueListItem,
  PerformoSettings,
  CompaniesApi,
  CompanyPagedCollectionApiResponse,
  QueryCompaniesRequest,
  Company
} from 'performo-api';
import { mapGetters } from 'vuex';

import { SortChangedEvent } from '@/models/SortChangedEvent';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {
    List
  },
  computed: mapGetters({
    settings: 'settings',
    api: 'workersApi',
    systemApi: 'systemApi',
    companiesApi: 'companiesApi'
  })
})
export default class WorkerPicker extends Vue {
  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false })
  private required!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: 'Worker' })
  private labelOverride?: string;

  private settings!: PerformoSettings;
  private systemApi!: SystemApi;
  private api!: WorkersApi;
  private companiesApi!: CompaniesApi;

  private internalTake = 25;

  private cols = [
    { displayName: 'Name', columnName: 'workerName', width: 'auto' },
    { displayName: 'Trade', columnName: 'tradeDisplay', width: 'auto' },
    { displayName: 'In/Out', columnName: 'inOut', width: '75px' },
    { displayName: 'Shift', columnName: 'shift', width: '90px' },
    { displayName: 'Vendor Id', columnName: 'vendorId', width: 'auto' },
    { displayName: 'Vendor Name', columnName: 'vendorName', width: 'auto' },
    { displayName: 'Selected', columnName: 'selected', width: '80px' }
  ];

  private vendorColumns = [
    { displayName: 'Name', columnName: 'companyName', width: 'auto' },
    { displayName: 'Code', columnName: 'companyCode', width: 'auto' },
    { displayName: 'Phone', columnName: 'phone', width: 'auto' },
    { displayName: 'Selected', columnName: 'selected', width: '80px' }
  ];

  get workers(): WorkerPagedCollectionApiResponse | undefined {
    if (this.pagedWorkers) {
      return this.pagedWorkers || [];
    }
    return undefined;
  }
  private pagedWorkers!: WorkerPagedCollectionApiResponse;

  get vendors(): CompanyPagedCollectionApiResponse | undefined {
    if (this.pagedVendors) {
      return this.pagedVendors || [];
    }
    return undefined;
  }
  private pagedVendors!: CompanyPagedCollectionApiResponse;

  private getListDisplayInitials(item: ValueListItem) {
    if (item && item.valueListValue) {
      const values = item.valueListValue?.split(' ');
      if (values && values?.length > 1) {
        return (
          values[0].charAt(0).toUpperCase() +
          values[values?.length - 1].charAt(0).toUpperCase()
        );
      } else {
        return values[0].substring(0, 2).toUpperCase();
      }
    }
  }

  private showModal = false;

  private workerVendorVlistQuery = '';
  private isVlistLoading = false;
  private workerVendorVlist: ValueListItem[] = [];

  private query!: ApiWorkersGetRequest;
  private vendorQuery!: QueryCompaniesRequest;

  private autoCompleteSelected(item: string) {
    this.$emit('input', item);
  }

  private itemClicked(item: Worker) {
    if (item) {
      this.$emit('input', item.workerName);
    } else {
      this.$emit('input', '');
    }
  }

  private vendorClicked(item: Company) {
    if (item) {
      this.$emit('input', item.companyName);
    } else {
      this.$emit('input', '');
    }
  }

  data() {
    // this lets the undefined query! refs become reactive
    // https://class-component.vuejs.org/guide/class-component.html#data
    return {
      query: undefined,
      vendorQuery: undefined,
      pagedWorkers: undefined,
      pagedVendors: undefined,
      workerVendorVlist: [],
      isVlistLoading: false,
      tab: 0
    };
  }

  private sortChangedHandler(sort: SortChangedEvent) {
    this.query.sortColumn = sort.column;
    this.query.sortDirection = sort.direction === 1 ? 'ascend' : 'descend';

    this.query.skip = 0;

    // sort changed, re-fetch the data from the server
    this.fetchWorkers();
  }

  private paginationChangeHandler(pageNumber: number) {
    this.query.skip = (this.query.take || 25) * (pageNumber - 1) + 1;
    this.fetchWorkers();
  }

  private vendorSortChangedHandler(sort: SortChangedEvent) {
    this.vendorQuery.sortColumn = sort.column;
    this.vendorQuery.sortDirection =
      sort.direction === 1 ? 'ascend' : 'descend';

    this.vendorQuery.skip = 0;

    // sort changed, re-fetch the data from the server
    this.fetchVendors();
  }

  private vendorPaginationChangeHandler(pageNumber: number) {
    this.vendorQuery.skip = (this.query.take || 25) * (pageNumber - 1) + 1;
    this.fetchVendors();
  }

  @Watch('workerVendorVlistQuery')
  private async queryVlist(val: string) {
    this.isVlistLoading = true;
    this.workerVendorVlist = await this.systemApi.getValueListItems({
      name: 'Workers',
      propertyId: this.propertyId
    });
    this.isVlistLoading = false;
    val;
  }

  @Watch('query', { deep: true })
  private async queryChanged(val: ApiWorkersGetRequest) {
    if (val) {
      this.fetchWorkers();
    }
  }

  @Watch('vendorQuery', { deep: true })
  private async vendorQueryChanged(val: QueryCompaniesRequest) {
    if (val) {
      this.fetchVendors();
    }
  }

  @Watch('propertyId')
  private async fetchWorkers() {
    const query = {
      ...this.query,
      propertyId: this.propertyId,
      skip: this.query.skip ? this.query.skip : 0,
      take: this.query.take ? this.query.take : this.internalTake,
      sortColumn: this.query.sortColumn !== '' ? this.query.sortColumn : '',
      sortDirection:
        this.query.sortDirection !== '' ? this.query.sortDirection : 'ascend'
    };
    try {
      this.pagedWorkers = await this.api.apiWorkersGet(query);
    } catch (error) {
      handleApiError(error);
    }
  }

  private async fetchVendors() {
    // note: vendors are system wide (despite having PropertyId field), so the that is *not* part of our query. (See discussion: https://dev.azure.com/wizardsoftware/Performo.Api/_workitems/edit/382)
    const query = {
      ...this.vendorQuery,
      companyName: this.vendorQuery.companyName
        ? this.vendorQuery.companyName
        : '*', // show a full list when empty
      skip: this.vendorQuery.skip ? this.vendorQuery.skip : 0,
      take: this.vendorQuery.take ? this.vendorQuery.take : this.internalTake,
      sortColumn:
        this.vendorQuery.sortColumn !== '' ? this.vendorQuery.sortColumn : '',
      sortDirection:
        this.vendorQuery.sortDirection !== ''
          ? this.vendorQuery.sortDirection
          : 'ascend'
    };
    try {
      this.pagedVendors = await this.companiesApi.queryCompanies(query);
    } catch (error) {
      handleApiError(error);
    }
  }

  private async mounted() {
    // must specify properties on objects that are to be reactive even if blank
    // see also -- https://stackoverflow.com/a/46667367/86860
    this.query = {
      workerName: '',
      sortColumn: 'workerName',
      sortDirection: 'ascend'
    };
    this.vendorQuery = {
      companyName: '',
      sortColumn: 'companyName',
      sortDirection: 'ascend'
    };

    this.fetchWorkers();
  }
}
